import * as t from 'io-ts';

export const preAlertPortFrom = t.union([
  t.literal('ANQING'),
  t.literal('BASUO'),
  t.literal('BEIJIAO'),
  t.literal('BENGBU'),
  t.literal('CAOFEIDIAN'),
  t.literal('CHANGQING'),
  t.literal('CHANGSHA'),
  t.literal('CHANGSHU'),
  t.literal('CHANGZHOU'),
  t.literal('CHIWAN'),
  t.literal('CHONGQING'),
  t.literal('DA CHAN BAY'),
  t.literal('DAAN'),
  t.literal('DAFENG'),
  t.literal('DALIAN'),
  t.literal('DANDONG'),
  t.literal('DAYA'),
  t.literal('DONGGUAN'),
  t.literal('FANGCHENG'),
  t.literal('FOSHAN'),
  t.literal('FUQING'),
  t.literal('FUZHOU'),
  t.literal('GAOGANG'),
  t.literal('GAOLAN'),
  t.literal('GUANGZHOU'),
  t.literal('HAIKOU'),
  t.literal('HAIMEN'),
  t.literal('HANGZHOU'),
  t.literal('HUADU'),
  t.literal('HUANGPU'),
  t.literal('HUANGSHI'),
  t.literal('HUIZHOU'),
  t.literal('HUNCUN'),
  t.literal('JIANGMEN'),
  t.literal('JIANGYIN'),
  t.literal('JINGTANG'),
  t.literal('JIUJIANG'),
  t.literal('LANSHANTOU'),
  t.literal('LANXI'),
  t.literal('LIANHUASHAN'),
  t.literal('LIANYUNGANG'),
  t.literal('LONGKOU'),
  t.literal('MACAU'),
  t.literal('MAWAN'),
  t.literal('MAWEI'),
  t.literal('NANCHANG'),
  t.literal('NANHAI'),
  t.literal('NANJING'),
  t.literal('NANSHA'),
  t.literal('NANTONG'),
  t.literal('NINGBO'),
  t.literal('QINGDAO'),
  t.literal('QINHUANGDAO'),
  t.literal('QUANZHOU'),
  t.literal('RIZHAO'),
  t.literal('RONGQI'),
  t.literal('SANSHAN'),
  t.literal('SANYA'),
  t.literal('SHANGHAI'),
  t.literal('SHANTOU'),
  t.literal('SHASHI'),
  t.literal('SHEKOU'),
  t.literal('SHENZHEN'),
  t.literal('SHIDAO'),
  t.literal('SHIJIU'),
  t.literal('SHUIDONG'),
  t.literal('SHUNDE'),
  t.literal('TAICANG'),
  t.literal('TAIPING'),
  t.literal('TAIZHOU'),
  t.literal('TANGGU'),
  t.literal('TIANJIN'),
  t.literal('TONGLING'),
  t.literal('TUMEN'),
  t.literal('WEIHAI'),
  t.literal('WENZHOU'),
  t.literal('WUHAN'),
  t.literal('WUHU'),
  t.literal('WUXI'),
  t.literal('WUZHOU'),
  t.literal('XIAMEN'),
  t.literal('XIAOSHAN'),
  t.literal('XINFENG'),
  t.literal('XINGANG'),
  t.literal('XINHUI'),
  t.literal('XINTANG'),
  t.literal('YANGSHAN'),
  t.literal('YANGZHOU'),
  t.literal('YANTAI'),
  t.literal('YANTIAN'),
  t.literal('YICHANG'),
  t.literal('YINGKOU'),
  t.literal('YUEYANG'),
  t.literal('ZHANGJIAGANG'),
  t.literal('ZHANGZHOU'),
  t.literal('ZHANJIANG'),
  t.literal('ZHAOQING'),
  t.literal('ZHAPU'),
  t.literal('ZHENHAI'),
  t.literal('ZHENJIANG'),
  t.literal('ZHONGSHAN'),
  t.literal('ZHOUSHAN'),
  t.literal('ZHUHAI'),
  t.literal(''),
]);

export const PORT_FROM = preAlertPortFrom.types.map((type) => type.value);
